var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnuler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.61,452.88c-10.72,0-21.43-4.09-29.62-12.27c-16.36-16.36-16.36-42.87,0-59.23L384.95,52.42 c16.36-16.36,42.87-16.36,59.23,0c16.36,16.35,16.36,42.88,0,59.23L115.23,440.61C107.05,448.79,96.33,452.88,85.61,452.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.45,410.99c0,10.72-4.09,21.43-12.27,29.62c-16.36,16.36-42.87,16.36-59.23,0L56,111.66 c-16.36-16.36-16.36-42.87,0-59.23c16.35-16.36,42.88-16.36,59.23,0l328.95,328.95C452.36,389.56,456.45,400.27,456.45,410.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnuler);
export default __webpack_public_path__ + "static/media/annuler.ec3af3e5d130a425c1a5b57a7395c24a.svg";
export { ForwardRef as ReactComponent };